/* eslint no-param-reassign : 0 */ // --> OFF
import React from 'react'
import {
  getUrl,
  mapHreflangTags,
  removeTrailingSlash,
  generateRandomKey,
} from '@utils'
import { useStaticQuery, graphql } from 'gatsby'

const TitleAndMetaTags = ({
  title,
  description,
  hrefLangUrls,
  image,
  isPHIgnite,
  canonicalSlug,
  locale,
  noIndex,
  noArchive,
  usDefault,
}) => {
  title = title ? `${title} | Paul Hastings LLP` : 'Paul Hastings LLP'
  const newUrl = new URL(getUrl())
  const origin = newUrl.origin
  const host = newUrl.host
  const protocol = newUrl.protocol
  const canonicalUrl = `${origin}${canonicalSlug}`
  const usCanonical = hrefLangUrls?.find(x => x.lang === 'en-US')

  const shareLogoQuery = useStaticQuery(graphql`
    query {
      allContentfulAsset(
        filter: { contentful_id: { eq: "3tBWFAfsj5J0DaAYCIZ9og" } }
      ) {
        edges {
          node {
            file {
              url
            }
          }
        }
      }
    }
  `)

  const defaultImage =
    shareLogoQuery?.allContentfulAsset?.edges[0]?.node?.file?.url
  const ogImage = image || defaultImage

  return (
    <>
      {/* General tags */}
      <title>{title}</title>
      <meta name="image" content={ogImage} />
      {isPHIgnite && <body className="has-bootstrap" />}
      {description && <meta name="description" content={description} />}

      {/* Schema.org tags */}
      {/* <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script> */}

      {/* OpenGraph tags */}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={locale} />
      <meta property="og:type" content="website" />
      <meta property="og:logo" content={defaultImage} />

      {/* Social tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@paulhastings" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:image" content={ogImage} />
      {description && <meta name="twitter:description" content={description} />}

      {/* HrefLang tags */}
      {hrefLangUrls
        ?.filter(x => x.lang !== 'en-US' && x.lang !== 'en-GB')
        ?.map(x => (
          <>
            <link
              key={generateRandomKey()}
              rel="alternate"
              hrefLang={mapHreflangTags(x.lang)}
              href={removeTrailingSlash(`${getUrl()}${x.href}`)}
            />
            <link
              key={generateRandomKey()}
              rel="alternate"
              hrefLang={x.lang}
              href={removeTrailingSlash(`${getUrl()}${x.href}`)}
            />
          </>
        ))}
      {hrefLangUrls
        ?.filter(x => x.lang === 'en-US')
        .map(x => (
          <>
            <link
              key={generateRandomKey()}
              rel="alternate"
              hrefLang="x-default"
              href={`${getUrl()}${x.href}`}
            />
            <link
              key={generateRandomKey()}
              rel="alternate"
              hrefLang="en"
              href={`${getUrl()}${x.href}`}
            />
            <link
              key={generateRandomKey()}
              rel="alternate"
              hrefLang={x.lang}
              href={`${getUrl()}${x.href}`}
            />
          </>
        ))}
      {hrefLangUrls
        ?.filter(x => x.lang === 'en-GB')
        .map(x => (
          <link
            key={generateRandomKey()}
            rel="alternate"
            hrefLang={x.lang}
            href={removeTrailingSlash(`${getUrl()}${x.href}`)}
          />
        ))}
      {/* Canonical URL */}
      {usDefault && usCanonical?.href ? (
        <link
          rel="canonical"
          href={removeTrailingSlash(`${getUrl()}${usCanonical?.href}`)}
          data-baseprotocol={protocol}
          data-basehost={host}
        />
      ) : (
        <link
          rel="canonical"
          href={removeTrailingSlash(canonicalUrl)}
          data-baseprotocol={protocol}
          data-basehost={host}
        />
      )}
      {/* REP tags */}
      {noIndex && <meta name="robots" content="noindex" />}
      {noArchive && <meta name="robots" content="noarchive" />}
    </>
  )
}

export default TitleAndMetaTags
